import { fetchApi } from "@/api/client";
import type { CategorySummary, PaginatedResponse } from "@/types/catalog";

// CR-110: thin fetchApi wrapper for the Generate-preview picker.
// Only ACTIVE categories are surfaced so operators can't target ARCHIVED/DRAFT.
export const API_CATEGORIES_PATH = "/api/categories" as const;

export async function listActiveCategories(
  signal?: AbortSignal,
): Promise<PaginatedResponse<CategorySummary>> {
  const qs = new URLSearchParams({
    status: "ACTIVE",
    page_size: "100",
  });
  return fetchApi<PaginatedResponse<CategorySummary>>(
    `${API_CATEGORIES_PATH}?${qs.toString()}`,
    { signal },
  );
}
